import React from 'react';
import { Modal, Button, Col, Row } from 'antd';
import { translate } from 'react-i18next';

class ConfirmSubject extends React.Component {


  render() {

    const t = this.props.t
    const subject_categories = this.props.subject_categories && Object.entries(this.props.subject_categories)

    return (
      <div>
        <Modal
          className="edituser"
          visible={this.props.open}
          onOk={this.props.save}
          onCancel={this.props.cancel}
        >
          <h4 style={{marginBottom: 20 }}>The following subjects are not in the system yet. Would you like to add these classes anyway and create new subjects?</h4>
            <ul>
            {this.props.data && this.props.data.map( (clss, i) =>
                <li>{clss[0]}</li>
              )
            }
            </ul>
        </Modal>
      </div>
    )
  }
}

export default ConfirmSubject;



// WEBPACK FOOTER //
// ./src/components/ConfirmSubject/index.jsx